let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6RcIS")).then(() => parcelRequire('33Ayl'));